import { Cartao } from './cartao';
import { Conta } from './conta';

export class VouchersParaConta {

    constructor(private vouchers: Array<Cartao>, private conta?: Conta) { }

    public getVouchers(): Array<Cartao> {
        return this.vouchers;
    }

    public setVouchers(vouchers: Array<Cartao>): void {
        this.vouchers = vouchers;
    }

    public getConta(): Conta {
        return this.conta;
    }

    public setConta(conta: Conta): void {
        this.conta = conta;
    }

}



// WEBPACK FOOTER //
// ./src/app/resources/classes/vouchersParaConta.ts